import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import set from 'lodash/set'
import get from 'lodash/get'
import sortBy from 'lodash/sortBy'
import sources from '@/sources'

Vue.use(Vuex)

export const storeConfig = {
  plugins: [createPersistedState({key: 'retribute'})],
  state: {
    accounts: {},
    sources: {},
    cache: {
      results: {}
    }
  },
  mutations: {
    reset (state) {
      state.accounts = {}
      state.sources = {}
      state.cache = {}
    },
    addAccount (state, payload) {
      const id = sources.sources[payload.source].authDataToKey(payload)
      payload.id = id
      Vue.set(state.accounts, id, payload)
    },
    disconnectAccount (state, {id}) {
      Vue.delete(state.accounts, id)
      if (state.cache.results) {
        Vue.delete(state.cache.results, id)
      }
    },
    setRecursiveState (state, {key, suffix, value}) {
      if (suffix) {
        let existing = get(state, key, {})
        existing[suffix] = value
        set(state, key, existing)
      } else {
        set(state, key, value)
      }
    }
  },
  getters: {
    sortedAccounts (state) {
      let values = Object.values(state.accounts)
      return sortBy(values, ["id"])
    },
  },
  actions: {

  }
}
export default new Vuex.Store(storeConfig)
